export default __webpack_public_path__ + "static/media/peripherals.6db50f91.svg";